import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/companycategories')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/companycategories/' + id , payload)       
    } else {
        return Api.post('api/companycategories' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/companycategories/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/companycategories/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};